function Icon() {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" strokeWidth="2" d="M0 4h18M3 9h12M6 14h6" />
    </svg>
  );
}

export default Icon;
